// Copyright 2023, Durable
import React, { ReactNode, Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorBoundaryDisplay from "../components/shared/Error";

/**
 * Component that wraps every route, handling lazy loading and error
 * boundaries.
 */
function RouteWrapper({ children }: { children: ReactNode }) {
  return (
    <Suspense fallback={<></>}>
      <ErrorBoundary fallback={<ErrorBoundaryDisplay />}>
        <div className="p-4 px-8">{children}</div>
      </ErrorBoundary>
    </Suspense>
  );
}

export default RouteWrapper;
